module.exports = __webpack_public_path__ + "static/img/name2.064bd37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cn/name2.png
// module id = ZmXC
// module chunks = 1